import apiClient from "./apiClient";
import { ApiCollectionResponse } from "../models/ResponseModels/ApiCollectionResponse";
import { ApiSingleResponse } from "../models/ResponseModels/ApiSingleResponse";
import { BookingInvoiceEmailResponse } from "../models/ResponseModels/BookingInvoiceEmailResponse";

interface GetBookingInvoicesParams {
  booking_id?: number;
  status?: string;
  per_page?: number;
}

export const getBookingInvoicesRequest = async (
  params?: GetBookingInvoicesParams,
): Promise<ApiCollectionResponse<BookingInvoiceEmailResponse>> => {
  const response = await apiClient.get<
    ApiCollectionResponse<BookingInvoiceEmailResponse>
  >("/booking-invoices", { params });

  return response.data;
};

export const getBookingInvoiceRequest = async (
  id: number,
): Promise<ApiSingleResponse<BookingInvoiceEmailResponse>> => {
  const response = await apiClient.get<
    ApiSingleResponse<BookingInvoiceEmailResponse>
  >(`/booking-invoices/${id}`);

  return response.data;
};
